export default {
  title: "Fontes de Dados",
  subtitle: "Gerencie as fontes de dados de {productName}",
  noDataSources: "Nenhuma fonte de dados encontrada",
  noDescription: "Sem descrição disponível",
  status: {
    active: "Ativo",
    inactive: "Inativo",
    error: "Erro",
    unknown: "Desconhecido"
  },
  type: {
    postgresql: "PostgreSQL",
    mongodb: "MongoDB",
    mysql: "MySQL",
    other: "Outro"
  }
} as const;
